// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AiJobController from "./ai_job_controller"
application.register("ai-job", AiJobController)

import AiRequestController from "./ai_request_controller"
application.register("ai-request", AiRequestController)

import AddedPlatesController from "./added_plates_controller"
application.register("added-plates", AddedPlatesController)

import AustonBoardController from "./auston_board_controller"
application.register("auston-board", AustonBoardController)

import HerselfBoardController from "./herself_board_controller"
application.register("herself-board", HerselfBoardController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import OnSiteController from "./on_site_controller"
application.register("on-site", OnSiteController)

import BeforeAfterController from "./before_after_controller"
application.register("before-after", BeforeAfterController)

import CameraSuggestController from "./camera_suggest_controller"
application.register("camera-suggest", CameraSuggestController)

import CastingPreviewController from "./casting_preview_controller"
application.register("casting-preview", CastingPreviewController)

import ReferencePickerController from "./reference_picker_controller"
application.register("reference-picker", ReferencePickerController)

import CepAutofillController from "./cep_autofill_controller"
application.register("cep-autofill", CepAutofillController)

import FoodReferencesController from "./food_references_controller"
application.register("food-references", FoodReferencesController)

import FormWizardController from "./form_wizard_controller"
application.register("form-wizard", FormWizardController)

import FramePickerController from "./frame_picker_controller"
application.register("frame-picker", FramePickerController)

import GarmentPiecesController from "./garment_pieces_controller"
application.register("garment-pieces", GarmentPiecesController)

import GeminiUploadController from "./gemini_upload_controller"
application.register("gemini-upload", GeminiUploadController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageCompressController from "./image_compress_controller"
application.register("image-compress", ImageCompressController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImageZoomController from "./image_zoom_controller"
application.register("image-zoom", ImageZoomController)

import IndustryToggleController from "./industry_toggle_controller"
application.register("industry-toggle", IndustryToggleController)

import InlineRenameController from "./inline_rename_controller"
application.register("inline-rename", InlineRenameController)

import LibraryPreviewController from "./library_preview_controller"
application.register("library-preview", LibraryPreviewController)

import LookbookLooksController from "./lookbook_looks_controller"
application.register("lookbook-looks", LookbookLooksController)

import MapsAutocompleteController from "./maps_autocomplete_controller"
application.register("maps-autocomplete", MapsAutocompleteController)

import MenuDishesController from "./menu_dishes_controller"
application.register("menu-dishes", MenuDishesController)

import MerchModeController from "./merch_mode_controller"
application.register("merch-mode", MerchModeController)

import ModelFilterController from "./model_filter_controller"
application.register("model-filter", ModelFilterController)

import ModelAssignController from "./model_assign_controller"
application.register("model-assign", ModelAssignController)

import PoseAudienceFilterController from "./pose_audience_filter_controller"
application.register("pose-audience-filter", PoseAudienceFilterController)

import PosePickerController from "./pose_picker_controller"
application.register("pose-picker", PosePickerController)

import ProductionBoardController from "./production_board_controller"
application.register("production-board", ProductionBoardController)

import OrderLibraryController from "./order_library_controller"
application.register("order-library", OrderLibraryController)

import PresetGuidelineController from "./preset_guideline_controller"
application.register("preset-guideline", PresetGuidelineController)

import PresetPickerController from "./preset_picker_controller"
application.register("preset-picker", PresetPickerController)

import PresetPrefillController from "./preset_prefill_controller"
application.register("preset-prefill", PresetPrefillController)

import ReTierController from "./re_tier_controller"
application.register("re-tier", ReTierController)

import RefineMaskController from "./refine_mask_controller"
application.register("refine-mask", RefineMaskController)

import RefinePanelController from "./refine_panel_controller"
application.register("refine-panel", RefinePanelController)

import RestagePanelController from "./restage_panel_controller"
application.register("restage-panel", RestagePanelController)

import RiachueloFramesController from "./riachuelo_frames_controller"
application.register("riachuelo-frames", RiachueloFramesController)

import RiachueloRecapController from "./riachuelo_recap_controller"
application.register("riachuelo-recap", RiachueloRecapController)

import RiachueloSlotController from "./riachuelo_slot_controller"
application.register("riachuelo-slot", RiachueloSlotController)

import RoomReferencesController from "./room_references_controller"
application.register("room-references", RoomReferencesController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SingleGenerationSelectionController from "./single_generation_selection_controller"
application.register("single-generation-selection", SingleGenerationSelectionController)

import SlotAvailabilityController from "./slot_availability_controller"
application.register("slot-availability", SlotAvailabilityController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import SuggestedCategoriesController from "./suggested_categories_controller"
application.register("suggested-categories", SuggestedCategoriesController)

import TeamGridController from "./team_grid_controller"
application.register("team-grid", TeamGridController)

import ZaloraVersionsController from "./zalora_versions_controller"
application.register("zalora-versions", ZaloraVersionsController)
